// extracted by mini-css-extract-plugin
export default {"navigation":"qEVV8myt","link":"CU5kGIWx","active":"adV5tGMO"};